import {FC, useEffect} from 'react';
import {Provider} from 'react-redux';

import ErrorBoundary from '~/common/ErrorBoundary';
import {renderApp} from '~/loader/render';
import {AppProps} from '~/loader/types';

import {Footer} from './components/Footer/Footer';
import {AppIds} from '../../constants';

const Root: FC<AppProps> = ({store}) => {
  useEffect(() => {
    document.getElementById('react-footer')?.setAttribute('data-rendered', 'true');
  }, []);

  return (
    <Provider store={store}>
      <ErrorBoundary errorBody={<div />}>
        <Footer />
      </ErrorBoundary>
    </Provider>
  );
};

renderApp(AppIds.Footer, Root);
